import Link from "next/link";
import { ArrowRight, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BENEFITS, STAT_TILES } from "./data";

export function BenefitsSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Why MSP Owners Choose Hub</h2>
            <div className="space-y-4">
              {BENEFITS.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle className="w-6 h-6 text-green-500 mr-3 flex-shrink-0" />
                  <span className="text-lg text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <Link href="https://westtn.consulting/en/contact" target="_blank">
                <Button size="lg" className="gap-2">
                  Get Started Today <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="relative h-full min-h-[400px] bg-white rounded-2xl shadow-xl p-8 border border-gray-100 flex flex-col justify-center">
            <div className="grid grid-cols-2 gap-4">
              {STAT_TILES.map((tile) => (
                <div key={tile.label} className={`${tile.bgClass} p-6 rounded-xl text-center`}>
                  <div className={`text-4xl font-bold ${tile.valueColorClass} mb-2`}>
                    {tile.value}
                  </div>
                  <div className="text-gray-600 font-medium">{tile.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
